import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import {
	backgroundColors,
	textColorsForBackground
} from 'lib/settings';

const Container = styled.div`
	margin: 0 0 40px 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const OptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const Option = styled.div`
	padding: 8px;
	border: 2px solid rgb(74, 144, 226, ${p => p.selected ? 1 : 0.3});
	border-radius: 2px;
	transition: border 0.1s ease-out;
	cursor: pointer;
	margin: 0 0 8px 0;

	&:hover {
		border: 2px solid rgb(74, 144, 226, ${p => p.selected ? 1 : 0.7});
	}
`;

const colors = Object.keys(backgroundColors).map(colorKey => {
	const color = backgroundColors[colorKey];

	return {
		value: color,
		name: `colors/${colorKey}`,
		textColor: textColorsForBackground[colorKey],
	}
});

class BackgroundColor extends React.Component {
	state = {
	  color: this.props.color,
	}

	changeHandler = color => {
	  this.setState({ color });
	  this.props.updateSettingsHandler({
	    'background-color': color,
	  })
	}

	render() {
	  const { t } = this.props;
	  return (
	    <Container>
	      <Label>{t('controls/common/settings/background color')}</Label>
	      <OptionsContainer>
	        {colors.map(color => (
	          <Option
	            key={color.value}
	            selected={this.state.color === color.value}
	            style={{ backgroundColor: color.value, color: color.textColor }}
	            onClick={() => this.changeHandler(color.value)}
	          >
	            {t(color.name)}
	          </Option>
	        ))}
	      </OptionsContainer>
	    </Container>
	  )
	}
}

BackgroundColor.propTypes = {
	t: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
	color: PropTypes.string,
}

export default translate('translations')(BackgroundColor)
